import { ForexTemplateWithDraft } from '@/feature/TrHistory/api/template/forex-template.interface';
import { mapForexBuyCreatedDraft } from '@/feature/TrHistory/api/form/forex-form.utils';

export const mapForexTemplate = (
	template?: ForexTemplateWithDraft
) => Object.assign(mapForexBuyCreatedDraft(template), {
	templateId: template?.templateId || 0,
	templateName: template?.templateName || ''
} as ForexTemplateWithDraft);
